import { OPERATOR_EMAILS } from '@forwardflow/constants/onboarding.constants'

export const isOperatorEmail = (email: string) => {
   return OPERATOR_EMAILS.has(email)
}
